import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const employeesNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Employees,
  route: RoutesEnum.Employees,
  icon: 'group',
};
